angular.module('task-project')
    .component('taskProjectBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<',
            btnXs: '<',
            onDeleted: '&'
        },
        templateUrl: "app/task/task-project/btn-options.html",
        controller: function ($rootScope, TaskProject, TaskProjectService, FilesLibrary, FilesSimpleUploadService) {
            this.TaskProjectService = TaskProjectService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.fileResourceName = 'task-project'
            this.execute0nDeleted = this.onDeleted || angular.noop;

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('task-project.updated'));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('task-project.updated'));

            this.show = () => TaskProjectService.show(this.item.id)
            this.edit = () => TaskProjectService.edit(this.item.id)

            this.delete = () => TaskProjectService.delete(this.item)
        }
    })
